import { useMutation } from '@gogame/query';
import { useScreenMessage } from '@gogame/screens';

import { startExportAudience } from 'scenes/CustomAudiences/Audiences/sources/audiences';

import { exportAudience } from '../queryKeyFactory';

export const useExportAudience = () => {
  const { showMessage } = useScreenMessage();
  const startExportAUMutation = useMutation(
    exportAudience(),
    startExportAudience,
    {
      refresh: false,
    }
  );

  const handleAction = async ({ id, config }) => {
    showMessage(
      `You will receive a link to the audience list to your email when ready`
    );

    const data = await startExportAUMutation.mutateAsync({ id: id, ...config });
    return data;
  };
  return [handleAction, startExportAUMutation];
};
